import React from "react"

const Section2: React.FC = () => {
  return (
    <div
      className={`w-[50%] h-full bg-center bg-contain relative overflow-hidden bg-[#f6f1eb]/50`}
    >
      <div className="w-full h-full">
        <div className="h-[50%] w-full flex flex-row">
          <div className="relative items-center bg-[#799177] w-[40%] h-[110%] ml-[20%] rounded-bl-[600px]">
            <div className="absolute top-[20%] left-[-100px] bg-[#164229] w-[200px] h-[200px] rounded-full items-center justify-center flex flex-col">
              <p className="font-playfair font-semibold text-2xl text-white">
                TRÀ
              </p>
              <p className="font-playfair font-semibold text-2xl text-white">
                XANH LÀI
              </p>
            </div>
            <div className="ml-[120px] flex-1 pr-[10px] pt-[5%]">
              <p className="font-playfair text-[#092b16] text-[16px]">
                Thành phần
              </p>
              <p className="text-white font-normal text-[13px] flex-wrap text-justify">
                98% trà xanh, 1% Hoa lài khô, 1% hương lài tổng hợp
              </p>
              <p className="font-playfair text-[#092b16] text-[16px]">
                Hương vị
              </p>
              <p className="text-white font-normal text-[13px] flex-wrap text-justify">
                Trà xanh lài có hương vị đặc trưng là sự kết hợp giữa vị chát
                nhẹ của trà xanh và hương thơm nồng nàn, thanh tao của hoa lài.
                Khi thưởng thức, bạn sẽ cảm nhận được vị chát ban đầu, sau đó là
                vị ngọt dịu, xen lẫn hương thơm thanh mát của hoa lài, tạo nên
                một trải nghiệm thư giãn và sảng khoái.
              </p>
            </div>
            <div className="absolute bottom-[-30px] right-[-30px] w-[100px]">
              <img
                className="w-full h-full object-cover"
                src="./logos/leaf-icon.png"
              />
            </div>
          </div>
          <div className=" flex-1 relative h-[200%] flex items-end pr-[30px] flex-col">
            <div className="min-h-[250px] mt-[30px] w-[160px] rounded-[600px]">
              <img
                className="w-full h-full object-cover rounded-[600px]"
                src="./banners/banner1.png"
                alt="Trà xanh lài"
              />
            </div>
            <div className="absolute bottom-0 w-[160px]">
              <div className="w-full h-180px rounded-t-[600px]">
                <img
                  className="w-full h-full object-cover rounded-t-[600px]"
                  src="./banners/banner2.png"
                />
              </div>
              <div className="relative w-full px-[15px] h-[160px] flex items-center justify-center bg-[#092b16] flex-col">
                <div className="flex-row flex gap-1">
                  <h1 className="font-playfair text-white text-[18px] text-center">
                    Sự kết hợp
                  </h1>
                  <img
                    className="w-[20px] h-[20px] object-contain"
                    src="./logos/leaf-white-icon.png"
                  />
                </div>
                <p className="text-white text-[11px] text-justify">
                  Sự kết hợp giữa vị chát, hương thơm và vị ngọt tạo nên sự hài
                  hòa, cân băng, mang đến một trải nghiệm thưởng trà độc đáo và
                  dễ chịu.
                </p>
                <div className="absolute w-full h-[160px] rounded-l-[600px] left-[-100%]">
                  <img
                    className="w-full h-full object-cover rounded-l-[600px]"
                    src="./banners/banner3.png"
                  />
                </div>
              </div>
              <div className="w-full h-[100px]">
                <img
                  className="w-full h-full object-cover"
                  src="./banners/banner4.png"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex-1 w-full h-[50%]">
          <div className="w-[40%] ml-[5%] pt-[20px]">
            <h1 className="font-playfair text-[#092b16] text-[36px]">
              Chi tiết mùi vị
            </h1>
            <p className="font-playfair font-bold text-[#092b16] text-[16px]">
              Hương thơm
            </p>
            <p className="text-[#092b16] text-[14px] text-justify flex-wrap">
              Hương hoa lài là điểm nhấn quan trọng, mùi thơm thoang thoảng cực
              kì dễ chịu, thanh mát, nhẹ nhàng nhưng để lại nhiều dư vị.
            </p>
            <p className="font-playfair font-bold text-[#092b16] text-[16px]">
              Vị Ngọt
            </p>
            <p className="text-[#092b16] text-[14px] text-justify flex-wrap">
              Sau vị chát, trà xanh lài để lại hậu vị ngọt, thường được so sánh
              với vị ngọt của mật ong, đọng lại lâu trên vòm miệng.
            </p>
            <p className="font-playfair font-bold text-[#092b16] text-[16px]">
              Vị Chát
            </p>
            <p className="text-[#092b16] text-[14px] text-justify flex-wrap">
              Trà xanh lài thường có vị chát nhẹ, đặc trưng của trà xanh, nhưng
              không quá gắt mà được làm dịu đi bởi hương hoa lài.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Section2
